export default __webpack_public_path__ + "static/media/platforms_web.4ec4b231.svg";